export default [
  46,
  58,
  59,
  60,
  62,
  20987,
  106,
  21004,
  21145,
  21146,
  21147,
  21148,
  21150,
  21151,
  21153,
  21154,
  21155,
  21156,
  21157,
  21158,
  21159,
  21160,
  21161,
  21162,
  21163,
  21167,
  21168,
  21169,
  21172,
  21176,
  21178,
  21181,
  21184,
  21209,
  21210,
  21217,
  21219,
  21221,
  21236,
  21239,
  21247,
  21249,
  21250,
  21252,
  21255,
  21256,
  21260,
  21264,
  21266,
  21271,
  21272,
  21273,
  21274,
  21275,
  41415,
  41417,
  41419,
  41421,
  41439,
  51451,
  51452,
  51453,
  51454,
  51455,
  61638,
  61642,
  61688,
  61644,
  61645,
  61654,
  61647,
  61648,
  61651,
  61652,
  61715,
  61716,
  61717,
  61718,
  61719,
  61720,
  61721,
  61725,
  61982,
  61991,
  72042,
  72043,
  72044,
  72045,
  72046,
  72047,
  72048,
  72049,
  72050
]



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderDetail/ProductSide/availableVendors.js